import { render, staticRenderFns } from "./SurveyAnalytics.vue?vue&type=template&id=52a67a3c&scoped=true&"
import script from "./SurveyAnalytics.vue?vue&type=script&lang=js&"
export * from "./SurveyAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SurveyAnalytics.vue?vue&type=style&index=0&id=52a67a3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a67a3c",
  null
  
)

export default component.exports